import gql from 'graphql-tag';
import { Component, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import ProjectCard from '../shared/projectCard.vue';
import SectionTitle from '../shared/sectionTitle.vue';
import SingleMainContainer from '../shared/singleMainContainer.vue';
import SuggestionsLists from './suggestionsLists.vue';

@Component({
  components: {
    ProjectCard,
    SingleMainContainer,
    SectionTitle,
    SuggestionsLists,
  },
})
export default class Project extends Vue {
  @Getter public loginInformation: any;

  public readonly projectQuery = gql`
    query($projectId: ID!) {
      project(projectId: $projectId) {
        id
        name
        goal
        requirements {
          keywords
          budget
        }
        library {
          id
          name
        }
        createdAt
        library {
          id
        }
      }
    }
  `;

  public get projectQueryVariables() {
    return {
      projectId: this.$route.params.projectId,
    };
  }
}
